/* VM winkelwagen-drawer
   De drawer wordt door Empire gekloond uit [data-templates] en bevat dan de winkelwagen
   van het moment van paginalading. Na elke wijziging halen we de verse Liquid op via de
   Section Rendering API, zodat de upsell-berekening server-side blijft en niet nagebouwd hoeft. */
(function () {
  "use strict";

  var SECTIE = "vm-cart-drawer";
  var laatsteVariant = null;
  var bezig = false;

  /* Onthouden wat er zojuist is toegevoegd, puur om die regel te laten oplichten. */
  function onthoud(body) {
    try {
      if (typeof body !== "string") return;
      var m = body.match(/(?:^|&)id=(\d+)/);
      if (m) laatsteVariant = m[1];
    } catch (e) {}
  }

  var xhrOpen = XMLHttpRequest.prototype.open;
  var xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (methode, url) {
    this.__vmUrl = url;
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    if (this.__vmUrl && String(this.__vmUrl).indexOf("/cart/add") !== -1) onthoud(body);
    return xhrSend.apply(this, arguments);
  };

  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function (input, init) {
      try {
        var url = typeof input === "string" ? input : (input && input.url) || "";
        if (url.indexOf("/cart/add") !== -1 && init && typeof init.body === "string") onthoud(init.body);
      } catch (e) {}
      return origFetch.apply(this, arguments);
    };
  }

  /* Zelfde opmaak als Shopify's money-filter in dit thema: euroteken zonder spatie. */
  var getal2 = new Intl.NumberFormat("nl-NL", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  function geld(centen) { return "\u20AC" + getal2.format(centen / 100); }

  var MEERVOUD = { koker: "kokers", fles: "flessen", zak: "zakken", emmer: "emmers", stuk: "stuks", set: "sets", rol: "rollen" };
  function meervoud(woord, n) { return n === 1 ? woord : (MEERVOUD[woord] || woord + "s"); }

  /* Aantallen die de klant zelf op een upsell-rij heeft gezet. Die moeten een verversing
     overleven, anders staat er straks 1 terwijl de klant 3 koos. Sleutel = variant-id. */
  var upsellAangepast = {};

  function werkStapBedragBij(rij) {
    var prijs = parseInt(rij.getAttribute("data-vm-prijs"), 10);
    var veld = rij.querySelector("[data-vm-qty-val]");
    var bedrag = rij.querySelector(".vm-cd-step__price b");
    if (!prijs || !veld || !bedrag) return;
    var n = parseInt(veld.textContent, 10) || 1;
    bedrag.textContent = geld(prijs * n);
    var was = rij.querySelector(".vm-cd-was");
    if (was) {
      var wasPrijs = parseInt(rij.getAttribute("data-vm-was"), 10);
      if (wasPrijs) was.textContent = geld(wasPrijs * n);
    }
    var label = rij.querySelector(".vm-cd-step__price span:last-child");
    if (label && /^voor /.test(label.textContent)) {
      label.textContent = "voor " + n + " " + meervoud(rij.getAttribute("data-vm-eenheid") || "stuk", n);
    }
  }

  function drawers() {
    return Array.prototype.slice.call(document.querySelectorAll(".atc-banner--container.vm-cd"))
      .filter(function (el) { return !el.closest("[data-templates]"); });
  }

  function markeer(drawer) {
    if (!laatsteVariant) return;
    var regel = drawer.querySelector('.vm-cd-regel[data-vm-variant="' + laatsteVariant + '"]');
    if (!regel) return;
    regel.classList.remove("vm-cd-regel--nieuw");
    void regel.offsetWidth; /* forceer herstart van de animatie */
    regel.classList.add("vm-cd-regel--nieuw");
    window.setTimeout(function () { regel.classList.remove("vm-cd-regel--nieuw"); }, 2100);
  }

  /* Na een toevoeging verschijnt er vaak een nieuwe stap onder de vouw. Die halen we in beeld,
     inclusief de voetregel eronder. Bij een gewone aantalwijziging houden we de scrollpositie vast,
     anders springt de lijst naar boven omdat we de innerHTML vervangen. */
  function naarUpsell(drawer) {
    var body = drawer.querySelector(".vm-cd__body");
    var blok = drawer.querySelector(".vm-cd-upsell");
    if (!body || !blok) return;
    var onder = blok.offsetTop + blok.offsetHeight + 14 - body.clientHeight;
    var doel = Math.max(0, Math.min(onder, body.scrollHeight - body.clientHeight));
    try {
      body.scrollTo({ top: doel, behavior: "smooth" });
    } catch (e) {
      body.scrollTop = doel;
    }
  }

  function focusMerk(drawer) {
    var a = document.activeElement;
    if (!a || !drawer.contains(a)) return null;
    var regel = a.closest ? a.closest(".vm-cd-regel[data-vm-key]") : null;
    if (regel) {
      var soort = a.hasAttribute("data-vm-plus") ? "plus"
        : a.hasAttribute("data-vm-min") ? "min"
        : a.hasAttribute("data-vm-weg") ? "weg"
        : (a.classList && a.classList.contains("vm-cd-teller__val")) ? "veld" : null;
      if (soort) return { type: "regel", key: regel.getAttribute("data-vm-key"), soort: soort, waarde: a.value };
    }
    if (a.id === "zipcode") return { type: "zipcode" };
    var dag = a.closest ? a.closest("[data-vm-dag]") : null;
    if (dag) return { type: "dag", waarde: dag.getAttribute("data-vm-dag") };
    return null;
  }

  function focusTerug(drawer, merk) {
    if (!merk) return;
    var el = null;
    if (merk.type === "regel") {
      var regel = drawer.querySelector('.vm-cd-regel[data-vm-key="' + merk.key + '"]');
      if (regel) {
        el = merk.soort === "veld"
          ? regel.querySelector(".vm-cd-teller__val")
          : regel.querySelector("[data-vm-" + merk.soort + "]");
        /* Een getypt maar nog niet bevestigd aantal mag niet verdwijnen onder je vingers. */
        if (merk.soort === "veld" && el && merk.waarde !== undefined) el.value = merk.waarde;
      }
    } else if (merk.type === "zipcode") {
      el = drawer.querySelector("#zipcode");
    } else if (merk.type === "dag") {
      el = drawer.querySelector('[data-vm-dag="' + merk.waarde + '"]');
    }
    if (!el) return;
    try { el.focus({ preventScroll: true }); } catch (e) {}
  }

  var nogEens = null;

  /* ------------------------------------------------------------------
     Nooit de DOM vervangen terwijl er een muisknop of vinger omlaag staat.
     Anders kan een verversing tussen mousedown en mouseup landen. De knop
     waarop je drukte is dan losgekoppeld, Chrome vuurt de klik op body, en
     Empire's document-afhandelaar ziet geen [data-atc-banner] boven zich
     en sluit de drawer. Dat treft precies het ritme van "plus op A, dan
     plus op B" en lijkt daardoor geen wedloop maar een harde bug.
  ------------------------------------------------------------------- */
  var vingerOmlaag = false;
  var klikBegonInPaneel = false;
  var uitgesteld = null;

  document.addEventListener("pointerdown", function (e) {
    var t = e.target;
    /* Alleen het PANEEL telt, niet de container. De container is de schermvullende
       donkere overlay; daarop klikken moet de drawer juist sluiten. */
    klikBegonInPaneel = !!(
      t && t.closest &&
      t.closest(".atc-banner--container.vm-cd") &&
      t.closest(".atc-banner--outer")
    );
    if (klikBegonInPaneel) vingerOmlaag = true;
  }, true);

  function vrijgeven() {
    vingerOmlaag = false;
    if (!uitgesteld) return;
    var taak = uitgesteld;
    uitgesteld = null;
    /* Op de volgende tick, zodat alle afhandelaars van de huidige klik
       (ook die van Empire) eerst klaar zijn met een DOM die nog intact is. */
    window.setTimeout(taak, 0);
  }

  /* vrijgeven() wordt aangeroepen vanuit de klik-afhandelaar hieronder, zodat hij ook
     draait als die stopImmediatePropagation gebruikt heeft. */
  document.addEventListener("pointercancel", vrijgeven, true);
  document.addEventListener("pointerup", function () {
    window.setTimeout(function () { if (vingerOmlaag) vrijgeven(); }, 250);
  }, true);

  function ververs(flits) {
    if (bezig) {
      /* Niet laten vallen: anders blijft het scherm achterlopen op de winkelwagen. */
      nogEens = flits;
      return Promise.resolve();
    }
    bezig = true;
    var lijst = drawers();
    var posities = lijst.map(function (d) {
      var b = d.querySelector(".vm-cd__body");
      return b ? b.scrollTop : 0;
    });
    var focusStaat = lijst.map(focusMerk);
    var upsellStaat = lijst.map(function (d) {
      var uit = {};
      d.querySelectorAll(".vm-cd-step").forEach(function (rij) {
        var knop = rij.querySelector("[data-vm-add]");
        var veld = rij.querySelector("[data-vm-qty-val]");
        if (knop && veld) uit[knop.getAttribute("data-vm-add")] = veld.textContent.trim();
      });
      return uit;
    });
    var datumStaat = lijst.map(function (d) {
      var blok = d.querySelector(".vm-cd-datum");
      if (!blok) return null;
      var veld = blok.querySelector("#zipcode");
      return { open: blok.open, postcode: veld ? veld.value : "" };
    });
    lijst.forEach(function (d) { d.classList.add("vm-cd--bezig"); });

    function afronden() {
      bezig = false;
      drawers().forEach(function (d) { d.classList.remove("vm-cd--bezig"); });
      if (nogEens !== null) {
        var volgende = nogEens;
        nogEens = null;
        ververs(volgende);
      }
    }

    return fetch(window.location.pathname + "?sections=" + SECTIE, { credentials: "same-origin" })
      .then(function (r) {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.json();
      })
      .then(function (data) {
        var html = data && data[SECTIE];
        if (!html) throw new Error("lege sectie");
        var doc = new DOMParser().parseFromString(html, "text/html");

        var toepassen = function () {
          lijst.forEach(function (drawer, i) {
            doc.querySelectorAll("[data-vm-part]").forEach(function (bron) {
              var naam = bron.getAttribute("data-vm-part");
              var doel = drawer.querySelector('[data-vm-part="' + naam + '"]');
              if (doel) doel.innerHTML = bron.innerHTML;
            });
            var body = drawer.querySelector(".vm-cd__body");
            if (body) body.scrollTop = posities[i] || 0;

            /* Wachtende aantallen terugzetten, anders loopt het scherm achter op de wachtrij. */
            Object.keys(wachtrij).forEach(function (sleutel) {
              var rg = drawer.querySelector('.vm-cd-regel[data-vm-key="' + sleutel + '"]');
              if (!rg) return;
              var vd = rg.querySelector(".vm-cd-teller__val");
              if (vd) { vd.value = wachtrij[sleutel]; vd.setAttribute("data-vm-vorig", wachtrij[sleutel]); }
              if (wachtrij[sleutel] === 0) rg.classList.add("vm-cd-regel--weg");
            });

            /* Zelf ingestelde upsell-aantallen terugzetten en het bedrag meerekenen. */
            drawer.querySelectorAll(".vm-cd-step").forEach(function (rij) {
              var knop = rij.querySelector("[data-vm-add]");
              if (!knop) return;
              var id = knop.getAttribute("data-vm-add");
              var eigen = upsellAangepast[id];
              if (eigen === undefined) eigen = (upsellStaat[i] || {})[id];
              if (eigen === undefined) return;
              var vd = rij.querySelector("[data-vm-qty-val]");
              if (vd && upsellAangepast[id] !== undefined) { vd.textContent = eigen; werkStapBedragBij(rij); }
            });

            var staat = datumStaat[i];
            var blok = drawer.querySelector(".vm-cd-datum");
            if (staat && blok) {
              blok.dataset.vmHerstel = "1";
              blok.open = staat.open;
              /* Een getypte postcode staat alleen in het geheugen van de component; hij komt
                 pas in cart.attributes.zip_code zodra er een datum is bevestigd. Afgaan op dat
                 serverattribuut wiste dus bij elke verversing de postcode en daarmee de hele
                 dagenlijst van iedereen die nog geen datum had gekozen. Altijd terugzetten.
                 Het opruimen van een verlopen datum gebeurt in bouwDagen, op het echte signaal. */
              var veld = blok.querySelector("#zipcode");
              if (staat.postcode && veld && !veld.value) {
                veld.value = staat.postcode;
                veld.dispatchEvent(new Event("input", { bubbles: true }));
              }
              window.setTimeout(function () { delete blok.dataset.vmHerstel; }, 120);
            }

            pasBlokkadeToe(drawer);
            meetDatumRuimte(drawer);
            var merk = focusStaat[i];
            if (!merk || merk.type !== "dag") focusTerug(drawer, merk);
            window.setTimeout(function () {
              bouwDagen(drawer);
              /* Dagknoppen bestaan pas na bouwDagen, dus die focus hier herstellen. */
              if (merk && merk.type === "dag") focusTerug(drawer, merk);
            }, 40);
            if (flits) markeer(drawer);
            if (flits === "upsell") {
              window.requestAnimationFrame(function () { naarUpsell(drawer); });
            }
          });
          afronden();
        };

        if (vingerOmlaag) uitgesteld = toepassen;
        else toepassen();
      })
      .catch(function (e) {
        if (window.console) console.warn("[vm-cart-drawer] verversen mislukt", e);
        /* Niet stil de oude winkelwagen blijven tonen: dat is precies hoe je een verkeerde
           bestelling laat plaatsen. Knoppen weer vrijgeven en de klant een uitweg bieden. */
        drawers().forEach(function (d) {
          d.querySelectorAll("[data-vm-add][disabled]").forEach(function (k) { k.disabled = false; });
          /* Niet met een verouderde blokkade blijven staan: dan kan de klant helemaal niet meer af. */
          var cta = d.querySelector(".vm-cd-cta");
          if (cta) { cta.disabled = false; cta.removeAttribute("aria-disabled"); }
          var melding = d.querySelector(".vm-cd-blokkade");
          if (melding && melding.parentNode) melding.parentNode.removeChild(melding);
          toonStoring(d, "We konden je winkelwagen niet bijwerken.");
        });
        afronden();
      });
  }

  /* De winkelwagenpagina zet Afrekenen uit bij minimale afname, losse bijbehorende
     producten en de Floorify-regel. Zonder dit kon je via de drawer langs die blokkades. */
  function pasBlokkadeToe(drawer) {
    var markering = drawer.querySelector("[data-vm-blokkade]");
    var knop = drawer.querySelector(".vm-cd-cta");
    var voet = drawer.querySelector(".vm-cd__foot");
    if (!knop || !voet) return;
    var bestaand = voet.querySelector(".vm-cd-blokkade");
    if (bestaand && bestaand.parentNode) bestaand.parentNode.removeChild(bestaand);

    if (!markering) {
      knop.disabled = false;
      knop.removeAttribute("aria-disabled");
      return;
    }
    knop.disabled = true;
    knop.setAttribute("aria-disabled", "true");
    var melding = document.createElement("p");
    melding.className = "vm-cd-blokkade";
    melding.textContent = markering.getAttribute("data-vm-blokkade");
    voet.insertBefore(melding, voet.firstChild);
  }

  /* Buiten [data-vm-part="body"] plaatsen: anders veegt de eerstvolgende verversing
     precies de melding weg die zegt dat er iets misging. */
  function toonStoring(drawer, tekst) {
    var binnen = drawer.querySelector(".vm-cd__inner");
    var body = drawer.querySelector(".vm-cd__body");
    if (!binnen || !body) return;
    var bestaand = drawer.querySelector(".vm-cd-storing");
    if (bestaand && bestaand.parentNode) bestaand.parentNode.removeChild(bestaand);
    var balk = document.createElement("div");
    balk.className = "vm-cd-storing";
    balk.innerHTML = "<span></span><button type=\"button\" data-vm-herlaad>Opnieuw laden</button>";
    balk.querySelector("span").textContent = tekst;
    binnen.insertBefore(balk, body);
  }

  /* Zelfde als post(), maar een niet-OK status is een fout en geen geldige uitkomst. */
  function postOf(url, data) {
    return post(url, data).then(function (r) {
      if (!r.ok) throw new Error("HTTP " + r.status);
      return r.json();
    });
  }

  function meldWinkelwagen(winkelwagen) {
    try {
      window.dispatchEvent(new CustomEvent("cartcount:update", { detail: winkelwagen }));
    } catch (e) {}
  }

  /* Meting: welke upsell-rij in de drawer is toegevoegd. Gaat als cart-attribuut mee de order
     in ("Upsell drawer": "variantId x aantal, ..."), bewust niet als line-item property, want
     die zou dezelfde variant in twee regels splitsen. Best effort: een mislukte meting mag het
     toevoegen nooit raken. Tegenhanger: noteerUpsell() in assets/cart.js. */
  function noteerUpsell(winkelwagen, variantId, aantal) {
    try {
      var sleutel = "Upsell drawer";
      var oud = (winkelwagen && winkelwagen.attributes && winkelwagen.attributes[sleutel]) || "";
      var attrs = {};
      attrs[sleutel] = (oud ? oud + ", " : "") + variantId + "x" + aantal;
      post("/cart/update.js", { attributes: attrs }).catch(function () {});
    } catch (e) {}
  }

  function post(url, data) {
    return fetch(url, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(data)
    });
  }

  /* Snel klikken op plus of min mag niet elke keer de halve drawer opnieuw tekenen.
     Het getal gaat direct in beeld, de winkelwagen wordt gebundeld bijgewerkt zodra je
     even stilhoudt. Dat voorkomt ook dat er een verversing tussen mousedown en mouseup
     valt, want dan vuurt de browser de klik op een hoger element en sluit Empire de drawer. */
  var wachtrij = {};
  var aantalTimer = null;

  var lopendeVerzending = null;
  var onderweg = null; /* kopie van wat nu verstuurd wordt, voor het vangnet bij wegnavigeren */

  /* De wachtrij mag pas leeg zijn als de server het heeft bevestigd. Anders ontstaat er een
     gat tussen "verstuurd" en "aangekomen" waarin het afrekenen denkt dat er niets openstaat. */
  function verstuurWachtrij() {
    if (aantalTimer) { clearTimeout(aantalTimer); aantalTimer = null; }
    if (lopendeVerzending) {
      /* Niet laten liggen: de timer is net gewist, dus zonder dit zou de rest van de
         wachtrij nooit verstuurd worden. Aanhaken op de lopende verzending. */
      if (!Object.keys(wachtrij).length) return lopendeVerzending;
      return lopendeVerzending.then(verstuurWachtrij, verstuurWachtrij);
    }
    var updates = wachtrij;
    if (!Object.keys(updates).length) return null;
    wachtrij = {};
    onderweg = updates;
    lopendeVerzending = postOf("/cart/update.js", { updates: updates })
      .then(function (winkelwagen) {
        lopendeVerzending = null;
        onderweg = null;
        meldWinkelwagen(winkelwagen);
        return winkelwagen;
      })
      .catch(function (e) {
        lopendeVerzending = null;
        onderweg = null;
        /* Terugleggen, anders is de wijziging definitief weg en heeft het vangnet niets meer. */
        Object.keys(updates).forEach(function (k) {
          if (!Object.prototype.hasOwnProperty.call(wachtrij, k)) wachtrij[k] = updates[k];
        });
        throw e;
      });
    return lopendeVerzending;
  }

  function ietsOpenstaand() {
    return !!lopendeVerzending || Object.keys(wachtrij).length > 0;
  }

  /* Server-side toetsen of afrekenen geblokkeerd is; niet vertrouwen op de DOM, want die kan
     achterlopen als er net een verversing bezig was. */
  function blokkadeVolgensServer() {
    return fetch(window.location.pathname + "?sections=" + SECTIE, { credentials: "same-origin" })
      .then(function (r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.json(); })
      .then(function (data) {
        var html = (data && data[SECTIE]) || "";
        var m = html.match(/data-vm-blokkade="([^"]*)"/);
        return m ? m[1].replace(/&#39;/g, "'").replace(/&quot;/g, '"').replace(/&amp;/g, "&") : null;
      });
  }

  function storingNa(tekst) {
    return ververs(false).then(function () {
      drawers().forEach(function (d) { toonStoring(d, tekst); });
    });
  }

  function planAantal(sleutel, aantal) {
    wachtrij[sleutel] = aantal;
    if (aantalTimer) clearTimeout(aantalTimer);
    aantalTimer = window.setTimeout(function () {
      var p = verstuurWachtrij();
      if (!p) return;
      p.then(function () { return ververs(false); })
        .catch(function () { storingNa("Je wijziging is niet opgeslagen."); });
    }, 450);
  }

  /* Afrekenen mag nooit vertrekken terwijl er nog een aantalwijziging in de wachtrij staat:
     dan zie je 3 en bestel je 1. Eerst wegschrijven, dan pas doorsturen. */
  var spoelBezig = false;
  window.addEventListener("pageshow", function (e) { if (e.persisted) spoelBezig = false; });

  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (spoelBezig || !form || !form.closest) return;
    var drawer = form.closest(".atc-banner--container.vm-cd");
    if (!drawer) return;
    if (!ietsOpenstaand()) return;

    e.preventDefault();
    var knop = e.submitter || form.querySelector('[name="checkout"]');
    var oudeTekst = knop ? knop.textContent : "";
    if (knop) { knop.disabled = true; knop.textContent = "Momentje\u2026"; }

    function vrij() {
      if (!knop) return;
      knop.disabled = false;
      knop.textContent = oudeTekst;
    }
    function verder() {
      spoelBezig = true;
      /* Een uitgeschakelde submitter levert per HTML-spec GEEN name/value-paar. Bleef de knop
         disabled, dan ontbrak name="checkout" in de POST en behandelde Shopify het als een
         gewone winkelwagen-update: de klant belandde op /cart in plaats van in de checkout. */
      if (knop) knop.disabled = false;
      if (form.requestSubmit) form.requestSubmit(knop);
      else {
        var verborgen = document.createElement("input");
        verborgen.type = "hidden";
        verborgen.name = "checkout";
        verborgen.value = "1";
        form.appendChild(verborgen);
        form.submit();
      }
    }

    var p = verstuurWachtrij() || lopendeVerzending || Promise.resolve();
    /* Nooit eindeloos blijven hangen zonder dat de klant iets ziet. */
    var klok = new Promise(function (_, weiger) {
      window.setTimeout(function () { weiger(new Error("time-out")); }, 8000);
    });

    Promise.race([p, klok])
      .then(blokkadeVolgensServer)
      .then(function (reden) {
        if (reden) {
          /* Niet doorsturen, en de knop niet eerst vrijgeven: anders is er een venster
             waarin hij klikbaar is terwijl de blokkade geldt. Alleen het label herstellen. */
          if (knop) {
            knop.textContent = oudeTekst;
            knop.disabled = true;
            knop.setAttribute("aria-disabled", "true");
          }
          ververs(false);
          toonStoring(drawer, reden);
          return;
        }
        verder();
      })
      .catch(function () {
        vrij();
        ververs(false);
        toonStoring(drawer, "Je wijziging is niet opgeslagen. Controleer je winkelwagen voor je afrekent.");
      });
  }, true);

  /* Laatste vangnet: sluit de klant het tabblad of navigeert hij weg, dan gaat de wachtrij
     alsnog mee. keepalive overleeft het afbreken van de pagina. */
  window.addEventListener("pagehide", function () {
    /* Een verzending die nog onderweg is gebruikt geen keepalive en wordt door de navigatie
       afgebroken. De wachtrij is dan al leeg, dus die payload moet hier alsnog mee. */
    var teSturen = {};
    if (onderweg) Object.keys(onderweg).forEach(function (k) { teSturen[k] = onderweg[k]; });
    Object.keys(wachtrij).forEach(function (k) { teSturen[k] = wachtrij[k]; });
    if (!Object.keys(teSturen).length) return;
    var body = JSON.stringify({ updates: teSturen });
    var gelukt = false;
    try {
      if (navigator.sendBeacon) {
        gelukt = navigator.sendBeacon("/cart/update.js", new Blob([body], { type: "application/json" }));
      }
      if (!gelukt) {
        fetch("/cart/update.js", {
          method: "POST", credentials: "same-origin", keepalive: true,
          headers: { "Content-Type": "application/json" }, body: body
        });
      }
    } catch (e) {}
    /* Opruimen, anders vuurt de timer na een terugkeer uit de bfcache nog een keer. */
    wachtrij = {};
    if (aantalTimer) { clearTimeout(aantalTimer); aantalTimer = null; }
  });

  function huidigAantal(regel) {
    var veld = regel.querySelector(".vm-cd-teller__val");
    if (!veld) return 0;
    return parseInt(veld.value, 10) || 0;
  }

  /* Empire's document-afhandelaar sluit de drawer zodra het aangeklikte element geen
     [data-atc-banner] boven zich heeft. Bij een klik waarvan het doelwit tussentijds uit de
     DOM verdween klopt die conclusie niet. Daarom beoordelen we het op de OORSPRONG van de
     klik (vastgelegd bij pointerdown) en houden we zo'n klik bij Empire weg.
     Onze eigen afhandelaar staat eerder geregistreerd dan die van Empire, dus dit werkt;
     cart-drawer.js van het thema staat er nog voor en blijft dus gewoon draaien. */
  function afhandelenKlik(e, drawer) {

    if (e.target.closest("[data-vm-herlaad]")) {
      e.preventDefault();
      window.location.reload();
      return;
    }

    /* Winkelwagen bekijken is een gewone link; wachtende wijzigingen moeten eerst weg. */
    var wagenLink = e.target.closest("[data-atc-banner-cart-button]");
    if (wagenLink && ietsOpenstaand()) {
      e.preventDefault();
      var bestemming = wagenLink.getAttribute("href");
      var pw = verstuurWachtrij() || lopendeVerzending || Promise.resolve();
      pw.then(function () { window.location.href = bestemming; })
        .catch(function () {
          /* Niet doorsturen met een wagen die niet klopt: de winkelwagenpagina zou dan
             andere aantallen tonen dan de klant net heeft ingesteld. */
          toonStoring(drawer, "Je wijziging is niet opgeslagen. Probeer het opnieuw.");
        });
      return;
    }

    /* teller van een upsell-rij, verandert alleen het getal */
    var stap = e.target.closest("[data-vm-step]");
    if (stap) {
      e.preventDefault();
      var rij = stap.closest(".vm-cd-step");
      var veld = rij && rij.querySelector("[data-vm-qty-val]");
      if (!veld) return;
      var nu = parseInt(veld.textContent, 10) || 1;
      var nieuw = nu + parseInt(stap.getAttribute("data-vm-step"), 10);
      veld.textContent = nieuw < 1 ? 1 : nieuw;
      var knopAdd = rij.querySelector("[data-vm-add]");
      if (knopAdd) upsellAangepast[knopAdd.getAttribute("data-vm-add")] = veld.textContent;
      werkStapBedragBij(rij);
      return;
    }

    var dag = e.target.closest("[data-vm-dag]");
    if (dag) {
      e.preventDefault();
      kiesDag(drawer, dag.getAttribute("data-vm-dag"));
      return;
    }

    var meerKnop = e.target.closest("[data-vm-meer]");
    if (meerKnop) {
      e.preventDefault();
      var houder = drawer.querySelector(".vm-cd-dagen");
      if (houder) {
        var meerNu = parseInt(houder.getAttribute("data-toon"), 10) || STAP_DAGEN;
        houder.setAttribute("data-toon", meerNu + STAP_DAGEN);
        /* Empire hangt een klikafhandelaar op document die de drawer sluit zodra het
           aangeklikte element niet meer binnen [data-atc-banner] zit. Bouwen we de lijst
           meteen opnieuw op, dan is deze knop al uit de DOM als Empire kijkt en gaat de
           drawer dicht. Daarom pas na deze klik. */
        window.setTimeout(function () { bouwDagen(drawer); }, 0);
      }
      return;
    }

    var add = e.target.closest("[data-vm-add]");
    if (add) {
      e.preventDefault();
      var rij2 = add.closest(".vm-cd-step");
      var veld2 = rij2 && rij2.querySelector("[data-vm-qty-val]");
      var aantal = veld2 ? parseInt(veld2.textContent, 10) || 1 : 1;
      var id = add.getAttribute("data-vm-add");
      add.disabled = true;
      laatsteVariant = id;
      postOf("/cart/add.js", { id: id, quantity: aantal })
        .then(function () {
          delete upsellAangepast[id];
          fetch("/cart.js", { credentials: "same-origin" })
            .then(function (r) { return r.json(); })
            .then(function (winkelwagen) {
              meldWinkelwagen(winkelwagen);
              noteerUpsell(winkelwagen, id, aantal);
            })
            .catch(function () {});
          return ververs("upsell");
        })
        .catch(function () {
          add.disabled = false;
          storingNa("Toevoegen is niet gelukt. Probeer het opnieuw.");
        });
      return;
    }

    var regel = e.target.closest(".vm-cd-regel[data-vm-key]");
    if (!regel) return;
    var sleutel = regel.getAttribute("data-vm-key");
    var doel = null;

    /* Uitgangspunt uit de wachtrij, niet uit het veld: een verversing kan het veld net
       hebben teruggezet op de serverwaarde, waardoor een klik verloren zou gaan. */
    var basis = Object.prototype.hasOwnProperty.call(wachtrij, sleutel)
      ? wachtrij[sleutel]
      : huidigAantal(regel);
    if (e.target.closest("[data-vm-plus]")) doel = basis + 1;
    else if (e.target.closest("[data-vm-min]")) doel = basis - 1;
    else if (e.target.closest("[data-vm-weg]")) doel = 0;
    else return;

    e.preventDefault();
    if (doel < 0) doel = 0;
    laatsteVariant = null;

    var teller = regel.querySelector(".vm-cd-teller__val");
    if (teller) {
      teller.value = doel;
      teller.setAttribute("data-vm-vorig", doel);
    }
    if (doel === 0) regel.classList.add("vm-cd-regel--weg");
    planAantal(sleutel, doel);
  }

  document.addEventListener("click", function (e) {
    var doelInDrawer = e.target && e.target.closest
      ? e.target.closest(".atc-banner--container.vm-cd")
      : null;
    var doelInPaneel = doelInDrawer && e.target.closest(".atc-banner--outer");
    var hoortBijPaneel = !!doelInPaneel || klikBegonInPaneel;
    klikBegonInPaneel = false;

    /* Alleen kliks in het paneel bij Empire weghouden. Een klik op de overlay eromheen
       moet hem juist bereiken, want dat is hoe sluiten-door-buiten-klikken werkt. */
    if (hoortBijPaneel) e.stopImmediatePropagation();

    try {
      if (doelInDrawer) afhandelenKlik(e, doelInDrawer);
    } finally {
      vrijgeven();
    }
  });

  /* Empire kloont de drawer bij het openen: dan pas weten we de juiste winkelwagen. */
  var observer = new MutationObserver(function (mutaties) {
    for (var i = 0; i < mutaties.length; i++) {
      var toegevoegd = mutaties[i].addedNodes;
      for (var j = 0; j < toegevoegd.length; j++) {
        var node = toegevoegd[j];
        if (node.nodeType !== 1) continue;
        var hit = node.matches && node.matches(".atc-banner--container.vm-cd")
          ? node
          : node.querySelector && node.querySelector(".atc-banner--container.vm-cd");
        if (hit && !hit.closest("[data-templates]")) {
          window.setTimeout(function () {
            drawers().forEach(pasBlokkadeToe);
            meetAlleDrawers();
            ververs(true);
          }, 60);
          return;
        }
      }
    }
  });

  /* De datumkiezer meet zichzelf op; in een dichtgeklapte details is dat 0 breed.
     Bij openen geven we hem een zetje. */
  document.addEventListener("toggle", function (e) {
    var blok = e.target;
    if (!blok || !blok.classList || !blok.classList.contains("vm-cd-datum")) return;

    /* Klasse op de drawer zodat de CSS weet dat het paneel openstaat; hij moet er ook weer
       af als de datum gekozen is en het paneel vanzelf dichtklapt. */
    var schil = blok.closest(".atc-banner--container.vm-cd");
    if (schil) {
      schil.classList.toggle("vm-cd--datum-open", blok.open);
      /* Twee keer: nu en na een frame, want de voet kan pas daarna zijn definitieve hoogte
         hebben als de lijst erboven net is gekrompen. */
      meetDatumRuimte(schil);
      window.requestAnimationFrame(function () { meetDatumRuimte(schil); });
    }
    if (!blok.open) return;
    window.dispatchEvent(new Event("resize"));
    var drawer = blok.closest(".atc-banner--container.vm-cd");
    if (!drawer) return;
    if (blok.dataset && blok.dataset.vmHerstel) {
      window.setTimeout(function () { bouwDagen(drawer); }, 30);
      return;
    }
    window.setTimeout(function () {
      bouwDagen(drawer);
      window.requestAnimationFrame(function () {
        /* Het blok staat nu vast boven het subtotaal, dus er valt niets meer naartoe te
           scrollen. Wel de cursor in het postcodeveld zetten als dat nog leeg is. */
        var postcode = blok.querySelector("#zipcode");
        if (postcode && !postcode.value) postcode.focus({ preventScroll: true });
      });
    }, 30);
  }, true);

  /* De verborgen sectie in de layout bestaat alleen zodat ?sections= hem kan renderen.
     Zijn DOM gebruiken we nooit, maar hij levert wel een tweede <delivery-date-picker>
     met dezelfde element-id's op. Daarom halen we hem meteen leeg. */

  /* ---------------------------------------------------------------
     Bezorgdatum als knoppenlijst in plaats van een kalender.
     De regels blijven van delivery-date-picker.js: _renderDatePickerCell()
     zegt of een dag mag, selectDate() zet hem in de cart-attributen.
     Hier wordt niets over levertijden opnieuw bedacht.
  ---------------------------------------------------------------- */
  var STAP_DAGEN = 6;
  var dagLabel = new Intl.DateTimeFormat("nl-NL", { weekday: "short", day: "numeric", month: "short" });

  /* AirDatepicker hangt zijn kalender aan body, dus buiten de drawer. In de drawer tonen we
     dagknoppen; die popup hoort er nooit te zijn. Hem alleen met CSS wegstrepen zolang de
     drawer openstaat was niet genoeg: zodra de klant de drawer sloot en verder winkelde viel
     die maskering weg en stond de kalender alsnog linksboven in beeld. Daarom show() hier
     uitzetten en een al geopende kalender dichtdoen. De winkelwagenpagina blijft ongemoeid:
     die heeft geen .vm-cd en komt hier dus nooit langs. */
  function dempKalender(el) {
    if (!el || el._vmKalenderGedempt) return;
    var picker = el.datePicker;
    if (!picker || typeof picker.show !== "function") return;
    el._vmKalenderGedempt = true;
    try { picker.hide(); } catch (e) {}
    picker.show = function () {};
  }

  function kiezer(drawer) {
    var el = drawer.querySelector("delivery-date-picker");
    dempKalender(el);
    return el;
  }

  function alsTekst(d) {
    function tl(n) { return n < 10 ? "0" + n : "" + n; }
    return tl(d.getDate()) + "-" + tl(d.getMonth() + 1) + "-" + d.getFullYear();
  }

  /* _activeDays wordt alleen gevuld door _updateDatePicker(). Die draait bij het opbouwen
     enkel als er een geldige selected-date binnenkomt. Komt de postcode wel uit de
     cart-attributen maar de datum niet, dan blijft de lijst leeg en staat bij PPC-datums
     elke dag uit. Daarom hier zelf aanzetten voor we gaan aftasten. */
  function zorgVoorDagen(el) {
    if (!el.zipCode) return;
    var leeg = !el._activeDays || !el._activeDays.length;
    if (!leeg || typeof el._updateDatePicker !== "function") return;
    try { el._updateDatePicker(false); } catch (e) {}
  }

  function beschikbareDagen(el, aantal) {
    zorgVoorDagen(el);
    var uit = [];
    var min = null;
    try { if (el.datePicker && el.datePicker.opts) min = el.datePicker.opts.minDate; } catch (e) {}
    if (!min) {
      var uren = el.getAttribute("contains-floor") === "true" ? 72 : 24;
      min = new Date(Date.now() + uren * 3600 * 1000);
    }
    var start = new Date(min.getFullYear(), min.getMonth(), min.getDate());
    for (var i = 0; i < 400 && uit.length < aantal; i++) {
      var kandidaat = new Date(start.getFullYear(), start.getMonth(), start.getDate() + i);
      var cel;
      try {
        cel = el._renderDatePickerCell(kandidaat);
      } catch (e) {
        /* Niet stil wegslikken: een fout hier betekent dat elke dag onbeschikbaar lijkt. */
        if (!beschikbareDagen._gemeld && window.console) {
          beschikbareDagen._gemeld = true;
          console.warn("[vm-cart-drawer] beschikbaarheid kan niet berekend worden", e);
        }
        cel = { disabled: true };
      }
      if (cel && !cel.disabled) uit.push(kandidaat);
    }
    return uit;
  }

  /* Exacte ruimte tussen kop en voet meten en als plafond op het datumpaneel zetten.
     Geen dvh-gok: de voet verschilt in hoogte met kortingsregels, de vertrouwensregel en
     de betaalmethoden. Zo groeit het paneel naar boven, blijft de onderkant tegen het
     subtotaal staan en kan het dat nooit bedekken. */
  function meetDatumRuimte(drawer) {
    var binnen = drawer.querySelector(".vm-cd__inner");
    var kop = drawer.querySelector(".vm-cd__head");
    var voet = drawer.querySelector(".vm-cd__foot");
    var paneel = drawer.querySelector(".vm-cd__datum");
    if (!binnen || !paneel) return;
    var hoogte = binnen.clientHeight;
    if (!hoogte) return;
    var over = hoogte - (kop ? kop.offsetHeight : 0) - (voet ? voet.offsetHeight : 0);
    paneel.style.maxHeight = Math.max(120, over) + "px";
  }

  function meetAlleDrawers() {
    drawers().forEach(meetDatumRuimte);
  }

  window.addEventListener("resize", meetAlleDrawers);
  window.addEventListener("orientationchange", meetAlleDrawers);

  function bouwDagen(drawer) {
    var el = kiezer(drawer);
    var romp = drawer.querySelector(".vm-cd-datum__body");
    if (!el || !romp) return;

    /* De component gooit een gekozen datum zelf weg als die door een gewijzigde winkelwagen
       niet meer kan (validateDateSelection). De pil in de kop komt uit Liquid van een moment
       daarvoor en zou blijven staan. selectedDate is de levende waarheid. */
    var pilKop = drawer.querySelector(".vm-cd-datum__gekozen");
    if (pilKop && !el.selectedDate && pilKop.parentNode) {
      pilKop.parentNode.removeChild(pilKop);
      zetDatumLabel(drawer, false);
    }

    var houder = romp.querySelector(".vm-cd-dagen");
    if (!el.zipCode) {
      if (houder) houder.parentNode.removeChild(houder);
      return;
    }
    if (!houder) {
      houder = document.createElement("div");
      houder.className = "vm-cd-dagen";
      houder.setAttribute("data-toon", STAP_DAGEN);
      var adres = romp.querySelector(".delivery-date__address");
      if (adres && adres.parentNode) adres.parentNode.insertBefore(houder, adres.nextSibling);
      else romp.appendChild(houder);
    }

    var toon = parseInt(houder.getAttribute("data-toon"), 10) || STAP_DAGEN;
    var dagen = beschikbareDagen(el, toon + 1);
    var meer = dagen.length > toon;
    dagen = dagen.slice(0, toon);

    var veld = el.querySelector("#delivery-date");
    var gekozen = veld ? veld.value : "";

    var html = '<div class="vm-cd-dagen__kop">Kies een beschikbare bezorgdatum</div>';
    if (!dagen.length) {
      /* Eerste keer niets gevonden kan ook "nog niet klaar" betekenen. Eén keer opnieuw
         proberen voor we de klant vertellen dat er niet bezorgd wordt. */
      var pogingen = parseInt(houder.getAttribute("data-poging"), 10) || 0;
      if (pogingen < 2) {
        houder.setAttribute("data-poging", pogingen + 1);
        html += '<p class="vm-cd-dagen__laden">Beschikbare dagen ophalen\u2026</p>';
        houder.innerHTML = html;
        window.setTimeout(function () { bouwDagen(drawer); }, 350);
        return;
      }
      html += '<p class="vm-cd-dagen__geen">Voor deze postcode vinden we geen bezorgdagen. Controleer de postcode of neem contact op.</p>';
    } else {
      houder.setAttribute("data-poging", "0");
      html += '<div class="vm-cd-dagen__rij">';
      dagen.forEach(function (d) {
        var waarde = alsTekst(d);
        var label = dagLabel.format(d).replace(/\./g, "");
        html += '<button type="button" class="vm-cd-dag' + (waarde === gekozen ? " is-gekozen" : "") +
                '" data-vm-dag="' + waarde + '">' + label + "</button>";
      });
      html += "</div>";
      if (meer) html += '<button type="button" class="vm-cd-dagen__meer" data-vm-meer>Toon latere bezorgdatums</button>';
    }
    houder.innerHTML = html;

    meetDatumRuimte(drawer);
  }

  /* <details> klapt van zichzelf hard om; een CSS-transitie pakt daar niet op omdat het
     element van display:none naar zichtbaar springt. Daarom de hoogte zelf animeren.
     Bij sluiten houden we het paneel open tot de animatie klaar is, anders is het al weg
     voordat er iets te zien valt. */
  function animeerHoogte(el, van, naar, klaar) {
    el.style.overflow = "hidden";
    var beweging = el.animate(
      [
        { height: van + "px", opacity: van ? 1 : 0.4 },
        { height: naar + "px", opacity: naar ? 1 : 0.4 }
      ],
      { duration: 220, easing: "cubic-bezier(.2,.6,.3,1)" }
    );
    function af() {
      el.style.overflow = "";
      el.style.height = "";
      if (klaar) klaar();
    }
    beweging.onfinish = af;
    beweging.oncancel = af;
  }

  document.addEventListener("click", function (e) {
    var kop = e.target.closest ? e.target.closest(".vm-cd-datum__kop") : null;
    if (!kop) return;
    var blok = kop.closest(".vm-cd-datum");
    var romp = blok && blok.querySelector(".vm-cd-datum__body");
    if (!blok || !romp || typeof romp.animate !== "function") return;
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    if (blok.open) {
      /* Sluiten: zelf afhandelen zodat we eerst kunnen animeren. */
      e.preventDefault();
      animeerHoogte(romp, romp.scrollHeight, 0, function () { blok.open = false; });
    } else {
      /* Openen doet <details> zelf; daarna van 0 naar de inhoudshoogte. */
      window.requestAnimationFrame(function () {
        animeerHoogte(romp, 0, romp.scrollHeight, null);
      });
    }
  }, true);

  /* Kop spiegelt of er al een datum ligt: kiezen of wijzigen. */
  function zetDatumLabel(drawer, gekozen) {
    var label = drawer.querySelector(".vm-cd-datum__label");
    if (!label) return;
    label.textContent = gekozen ? "Gekozen bezorgdatum" : "Bezorgdatum kiezen";
  }

  function zetDatumPil(drawer, waarde) {
    var kop = drawer.querySelector(".vm-cd-datum__kop");
    if (!kop) return null;
    var pil = kop.querySelector(".vm-cd-datum__gekozen");
    if (!waarde) {
      if (pil && pil.parentNode) pil.parentNode.removeChild(pil);
      return null;
    }
    if (!pil) {
      pil = document.createElement("span");
      pil.className = "vm-cd-datum__gekozen";
      var label = kop.querySelector(".vm-cd-datum__label");
      if (label && label.parentNode) label.parentNode.insertBefore(pil, label.nextSibling);
    }
    pil.textContent = waarde;
    return pil;
  }

  function dagFout(drawer, melding) {
    var houder = drawer.querySelector(".vm-cd-dagen");
    if (!houder) return;
    var regel = houder.querySelector(".vm-cd-dagen__fout");
    if (!regel) {
      regel = document.createElement("p");
      regel.className = "vm-cd-dagen__fout";
      houder.appendChild(regel);
    }
    regel.textContent = melding;
  }

  function kiesDag(drawer, waarde) {
    var el = kiezer(drawer);
    if (!el) return;
    var d = waarde.split("-");
    var datum = new Date(parseInt(d[2], 10), parseInt(d[1], 10) - 1, parseInt(d[0], 10));
    var knop = drawer.querySelector('[data-vm-dag="' + waarde + '"]');

    /* Meteen bevestigen. Wachten op /cart/update.js kostte een halve seconde waarin er
       zichtbaar niets gebeurde. We tonen de keuze nu direct en draaien hem terug als het
       wegschrijven mislukt; dat is zeldzaam en wordt dan duidelijk gemeld. */
    var vorigeFout = drawer.querySelector(".vm-cd-dagen__fout");
    if (vorigeFout && vorigeFout.parentNode) vorigeFout.parentNode.removeChild(vorigeFout);

    var eerderGekozen = drawer.querySelector("[data-vm-dag].is-gekozen");
    if (eerderGekozen) eerderGekozen.classList.remove("is-gekozen");
    if (knop) knop.classList.add("is-gekozen");
    zetDatumPil(drawer, waarde);
    zetDatumLabel(drawer, true);

    try { if (el.datePicker) el.datePicker.selectDate(datum, { silent: true }); } catch (e) {}
    try { el.selectedDate = datum; } catch (e) {}

    /* Dichtklappen met de oplichtende pil, zonder op het netwerk te wachten. */
    window.setTimeout(function () {
      var blok = drawer.querySelector(".vm-cd-datum");
      if (blok) blok.open = false;
      var pil = drawer.querySelector(".vm-cd-datum__gekozen");
      if (pil) {
        pil.classList.remove("vm-cd-datum__gekozen--nieuw");
        void pil.offsetWidth;
        pil.classList.add("vm-cd-datum__gekozen--nieuw");
        window.setTimeout(function () {
          pil.classList.remove("vm-cd-datum__gekozen--nieuw");
        }, 1700);
      }
    }, 240);

    postOf("/cart/update.js", {
      attributes: {
        delivery_date: waarde,
        zip_code: el.zipCode || "",
        country: el.country || "NL"
      }
    })
      .then(function (winkelwagen) {
        var opgeslagen = winkelwagen && winkelwagen.attributes && winkelwagen.attributes.delivery_date;
        if (opgeslagen !== waarde) throw new Error("niet opgeslagen");
      })
      .catch(function () {
        /* Terugdraaien: de klant mag niet denken dat er een datum ligt die er niet is. */
        try { el.selectedDate = null; } catch (e) {}
        if (knop) knop.classList.remove("is-gekozen");
        zetDatumPil(drawer, null);
        zetDatumLabel(drawer, false);
        var blok = drawer.querySelector(".vm-cd-datum");
        if (blok) blok.open = true;
        dagFout(drawer, "Je bezorgdatum kon niet worden opgeslagen. Probeer het opnieuw.");
      });
  }

  var dagTimer = null;
  document.addEventListener("input", function (e) {
    if (!e.target || e.target.id !== "zipcode") return;
    var drawer = e.target.closest(".atc-banner--container.vm-cd");
    if (!drawer) return;
    if (dagTimer) clearTimeout(dagTimer);
    dagTimer = window.setTimeout(function () { bouwDagen(drawer); }, 300);
  });
  document.addEventListener("change", function (e) {
    if (!e.target || e.target.id !== "country") return;
    var drawer = e.target.closest(".atc-banner--container.vm-cd");
    if (drawer) bouwDagen(drawer);
  });

  /* Zolang de drawer open staat mag de pagina eronder niet meescrollen. */
  function zetSlot() {
    var open = false;
    drawers().forEach(function (d) {
      if (d.getAttribute("data-animation-state") === "open") open = true;
    });
    document.documentElement.classList.toggle("vm-cd-open", open);
    /* Vangnet: is de kalender toch opengeklapt voor we hem konden dempen, dan gaat hij hier
       dicht op het moment dat de maskering wegvalt. */
    if (!open) drawers().forEach(function (d) { kiezer(d); });
  }

  var slotObserver = new MutationObserver(zetSlot);

  function leegStub() {
    var stub = document.querySelector("[data-vm-cart-drawer-bron]");
    if (stub) stub.innerHTML = "";
  }

  function start() {
    leegStub();
    observer.observe(document.body, { childList: true, subtree: true });
    slotObserver.observe(document.body, {
      attributes: true,
      subtree: true,
      childList: true,
      attributeFilter: ["data-animation-state"]
    });
    zetSlot();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
